module.exports = __webpack_public_path__ + "static/media/180.df85f2bf.jpg";